import { createContext } from 'react';

const NewsContext = createContext(void 0);

NewsContext.displayName = 'context(news)';

export default NewsContext;